<div id="layout-wrapper" class="min-h-screen bg-gray-50">
    <!-- Top Bar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>

    <!-- Side Bar -->
    <app-sidebar></app-sidebar>
    
    <!-- Main -->
    <div class="main-content transition-all duration-300 flex flex-col min-h-screen"
         [ngClass]="{
           'ml-0 md:ml-64': sidebarSize === 'lg' || sidebarSize === null,
           'ml-0 md:ml-20': sidebarSize === 'sm',
           'ml-0 md:ml-16': sidebarSize === 'sm-hover'
         }">
        <div class="page-content flex-1">
            <app-free-trial-banner *ngIf="isFreeTrial"></app-free-trial-banner>
            <div class="container-fluid">
                <router-outlet></router-outlet>
            </div>
        </div>

        <!-- Footer -->
        <app-footer></app-footer>
    </div>
</div>

<!--
<div class="fixed bottom-6 right-6">
  <button class="btn btn-secondary"
            type="button"
            (click)="onShowFeedback()">
        Support
    </button>
</div>
-->